import { render, staticRenderFns } from "./TimeRangePresetButtons.vue?vue&type=template&id=2388caa3"
import script from "./TimeRangePresetButtons.vue?vue&type=script&lang=js"
export * from "./TimeRangePresetButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Development/graduation/graduate-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports